import { render, staticRenderFns } from "./_DataTable.vue?vue&type=template&id=89df657e&scoped=true"
import script from "./_DataTable.vue?vue&type=script&lang=ts"
export * from "./_DataTable.vue?vue&type=script&lang=ts"
import style0 from "./_DataTable.vue?vue&type=style&index=0&id=89df657e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89df657e",
  null
  
)

export default component.exports